import { render, staticRenderFns } from "./NewMilestoneModal.vue?vue&type=template&id=3c15806f&scoped=true&"
import script from "./NewMilestoneModal.vue?vue&type=script&lang=js&"
export * from "./NewMilestoneModal.vue?vue&type=script&lang=js&"
import style0 from "./NewMilestoneModal.vue?vue&type=style&index=0&id=3c15806f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c15806f",
  null
  
)

export default component.exports